"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DateSelectOptions = void 0;
var react_1 = __importDefault(require("react"));
var formatNumberWithSuffix = function (int) {
    if (int > 3 && int < 21) {
        return "".concat(int, "th");
    }
    switch (int % 10) {
        case 1:
            return "".concat(int, "st");
        case 2:
            return "".concat(int, "nd");
        case 3:
            return "".concat(int, "rd");
        default:
            return "".concat(int, "th");
    }
};
var DateSelectOptions = function () { return (react_1.default.createElement(react_1.default.Fragment, null, new Array(28).fill(0).map(function (_, index) {
    var day = index + 1;
    return (react_1.default.createElement("option", { key: index, value: day }, formatNumberWithSuffix(day)));
}))); };
exports.DateSelectOptions = DateSelectOptions;
